import { useSyncExternalStore } from 'react';

import { type Preferences, preferencesStore } from '../preferences/preferences-store';

export function usePreferences(): Preferences & {
  setTheme: typeof preferencesStore.setTheme;
  setTextSize: typeof preferencesStore.setTextSize;
} {
  const preferences = useSyncExternalStore(preferencesStore.subscribe, preferencesStore.get);
  return {
    ...preferences,
    setTheme: preferencesStore.setTheme,
    setTextSize: preferencesStore.setTextSize,
  };
}
